import { accessoriesPageParamName } from '../../../config/urlParams';

import Pagination from '../../../container/pagination/Pagination';

import {
  type ChangeAccessoriesPageAtomPromise,
  recommendationsLastPageLoadedIncludingLoadMoreAtom,
} from '../../../effect/atom/products/recommendationsPagination';
import type { HydraViewExtended } from '@vs-shop/schemas/openapi/hydraView';

type Props = {
  hydraViewExtended: HydraViewExtended;
  changePage: ChangeAccessoriesPageAtomPromise;
  scrollToAccessoriesGrid: () => void;
  baseUrl: string;
};

export default function AccessoriesPagination({
  hydraViewExtended,
  changePage,
  scrollToAccessoriesGrid,
  baseUrl,
}: Props) {
  return (
    <Pagination
      hydraViewExtended={hydraViewExtended}
      changePage={changePage}
      scrollToGrid={scrollToAccessoriesGrid}
      baseUrl={baseUrl}
      lastPageLoadedIncludingLoadMoreAtom={recommendationsLastPageLoadedIncludingLoadMoreAtom}
      pageParamName={accessoriesPageParamName}
    />
  );
}
